// tslint:disable-next-line: eofline
export const ApiUrl = 'https://www.qa.auth.wbidmax.com/WBidCoreService/api/';
// export const ApiUrl = 'http://localhost:61541/api/';
//  export const ApiUrl = "https://www.auth.wbidmax.com/WBidCoreServiceTest/api/";
//export const ApiUrl = "https://www.auth.wbidmax.com/WBidCoreServiceTestDBQA/api/";
